import { mailEditorBelowToolbarSx, mailEditorToolbarRowSx } from "../mailsEditor/mailEditorShared";

export {
  mailEditorBelowToolbarSx as smsEditorBelowToolbarSx,
  mailEditorToolbarRowSx as smsEditorToolbarRowSx,
};

/** Replace {{.Key}} with catalog examples for live preview. */
export function renderSMSPreviewBody(
  body: string,
  placeholders: readonly { key: string; example?: string; label: string }[],
): string {
  let out = body;

  for (const ph of placeholders) {
    const re = new RegExp(`\\{\\{\\s*\\.?${ph.key}\\s*\\}\\}`, "g");
    out = out.replace(re, ph.example?.trim() || ph.label);
  }

  return out;
}
